import { useState } from "react";

export const useRecentlyUsed = () => {
  const [recentlyUsed, setRecentlyUsed] = useLocalStorage("recentlyUsed", []);

  function onCustomerSelect(customer, callback?: () => void) {
    if (recentlyUsed.includes(customer.shortID)) {
      // put element one index lower in the array
      // so the most relevant elements are on top
      const index = recentlyUsed.indexOf(customer.shortID);
      if (index - 1 < 0) return;
      const before = recentlyUsed[index - 1];
      const current = recentlyUsed[index];
      recentlyUsed[index] = before;
      recentlyUsed[index - 1] = current;
      setRecentlyUsed([...recentlyUsed]);
      callback?.();
    } else {
      setRecentlyUsed([...recentlyUsed, customer.shortID]);
      callback?.();
    }
  }

  return {
    recentlyUsed,
    onCustomerSelect,
  };
};

export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}
